import { ICheckAuthResult } from './user.models';

export const hasAuthenticatedSub = (
    result: ICheckAuthResult,
): result is { isAuthenticated: true; userData: { sub: string } } => {
    return (
        result.isAuthenticated === true &&
        typeof result.userData?.sub === 'string' &&
        result.userData.sub.length > 0
    );
};
